import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
const messages = [
  {
    text: "שירות מקצועי ומהיר",
    icon: <LocalPhoneIcon sx={{ fontSize: 16, ml: 0.5 }} />,
  },
  {
    text: "מלאי זמין",
    icon: <ShoppingCartIcon sx={{ fontSize: 16, ml: 0.5 }} />,
  },
  {
    text: " אספקה בפריסה ארצית",
    icon: <LocalShippingIcon sx={{ fontSize: 16, ml: 0.5 }} />,
  },
];

const TopBanner = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % messages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY < 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? messages.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % messages.length);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1300,
        height: "32px",
        backgroundColor: "#FDFBF6",
        borderBottom: "1px solid #E0E0E0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 1,
        transform: isVisible ? "translateY(0)" : "translateY(-100%)",
        transition: "transform 0.3s ease-in-out",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <IconButton
          onClick={handlePrev}
          size="small"
          sx={{ color: "#444", p: 0.5 }}
        >
          <ChevronRightIcon fontSize="small" />
        </IconButton>

        <Typography
          sx={{
            fontSize: "0.85rem",
            color: "#444",
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          {messages[currentIndex].text}
          {messages[currentIndex].icon}
        </Typography>

        <IconButton
          onClick={handleNext}
          size="small"
          sx={{ color: "#444", p: 0.5 }}
        >
          <ChevronLeftIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default TopBanner;
